/* eslint-disable sort-keys */
export const urls: Record<
  'pt-en',
  Record<string, '/l/pt/en' | `/l/pt/en/${string}`>
> = {
  'pt-en': {
    // Home
    '': '/l/pt/en/home',

    // Alumni
    alumni: '/l/pt/en/alumni',

    // B2B
    enterprise: '/l/pt/en/b2b',
    'enterprise/contact': '/l/pt/en/b2b/apply',

    // Campus
    lisbon: '/l/pt/en/campus/lis',
    remote: '/l/pt/en/campus/rmt',

    // Career
    career: '/l/pt/en/career',

    // Courses
    'web-development': '/l/pt/en/course/wd',
    'data-analytics': '/l/pt/en/course/da',
    'ux-ui-design': '/l/pt/en/course/ux',
    cybersecurity: '/l/pt/en/course/cy',

    // FAQ
    faq: '/l/pt/en/faq',

    // Financing Options
    'financing-options': '/l/pt/en/financing',

    // Forms
    apply: '/l/pt/en/apply',
    apply2: '/l/pt/en/full-apply',
    contact: '/l/pt/en/contact',
    'financing-form': '/l/pt/en/financing-form',
    'thank-you': '/l/pt/en/thank-you',

    // Quiz
    quiz: '/l/pt/en/quiz',
    'artificial-intelligence/match': '/l/pt/en/quiz-match/ai',
    'cybersecurity/match': '/l/pt/en/quiz-match/cy',
    'data-analytics/match': '/l/pt/en/quiz-match/da',
    'devops-cloud-computing/match': '/l/pt/en/quiz-match/dv',
    'digital-marketing/match': '/l/pt/en/quiz-match/mk',
    'data-science-machine-learning/match': '/l/pt/en/quiz-match/ml',
    'ux-ui-design/match': '/l/pt/en/quiz-match/ux',
    'web-development/match': '/l/pt/en/quiz-match/wd',

    // Syllabus Forms
    'ai-consulting-integration/syllabus': '/l/pt/en/syllabus/ac',
    'artificial-intelligence/syllabus': '/l/pt/en/syllabus/ai',
    'cloud-engineer/syllabus': '/l/pt/en/syllabus/ce',
    'cybersecurity/syllabus': '/l/pt/en/syllabus/cy',
    'data-analytics/syllabus': '/l/pt/en/syllabus/da',
    'data-engineering/syllabus': '/l/pt/en/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/pt/en/syllabus/dv',
    'digital-marketing/syllabus': '/l/pt/en/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/pt/en/syllabus/ml',
    'ai-product-manager/syllabus': '/l/pt/en/syllabus/pm',
    'ux-ui-design/syllabus': '/l/pt/en/syllabus/ux',
    'web-development/syllabus': '/l/pt/en/syllabus/wd',

    // PDP
    'ai-consulting-integration/remote': '/l/pt/en/pdp/ac/rmt',
    'artificial-intelligence/remote': '/l/pt/en/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/pt/en/pdp/ce/rmt',
    'cybersecurity/lisbon': '/l/pt/en/pdp/cy/lis',
    'cybersecurity/remote': '/l/pt/en/pdp/cy/rmt',
    'data-analytics/lisbon': '/l/pt/en/pdp/da/lis',
    'data-analytics/remote': '/l/pt/en/pdp/da/rmt',
    'data-engineering/remote': '/l/pt/en/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/pt/en/pdp/dv/rmt',
    'digital-marketing/remote': '/l/pt/en/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/pt/en/pdp/ml/rmt',
    'ai-product-manager/remote': '/l/pt/en/pdp/pm/rmt',
    'ux-ui-design/lisbon': '/l/pt/en/pdp/ux/lis',
    'ux-ui-design/remote': '/l/pt/en/pdp/ux/rmt',
  },
};
/* eslint-enable sort-keys */
